
import { Injectable } from '@angular/core';

export interface AffTrackInfo {
    affId: string;
    clickId?: string;
    subId?: string;
}

export type AffTrackParam = keyof AffTrackInfo;

@Injectable({ providedIn: 'root' })
export class AffiliateService {
    private COOKIE_TTL_DAYS = 90;
    private LS_PREFIX = 'aff.';
    private AFFILIATE_PARAM = 'utm_source';
    private SUBID_PARAM = 'utm_content';
    private CLICKID_PARAM = 'utm_term';

    private PARAMS_MAP : Record<AffTrackParam, string> = {
        affId: this.AFFILIATE_PARAM,
        clickId: this.CLICKID_PARAM,
        subId: this.SUBID_PARAM,
    };

    private cookies: Record<string, string> = {};

    init() {
        const params = new URLSearchParams(location.search);
        const affId = params.get(this.AFFILIATE_PARAM);
        if(affId && affId.startsWith('aff')) {
            params.set(this.AFFILIATE_PARAM, affId.replace('aff', ''));
            const affTrackInfo: AffTrackInfo = {affId: ''};
            Object.keys(this.PARAMS_MAP).forEach((key: string) => {
                const value = params.get(this.PARAMS_MAP[key as AffTrackParam]);
                value && (affTrackInfo[key as AffTrackParam] = value);
            });
            this.save(affTrackInfo);
        }
    }

    get(): AffTrackInfo | undefined {
        this.loadCookies();
        const affId = this.getItem('affId');
        if(affId) {
            const affTrackInfo: AffTrackInfo = {affId};
            Object.keys(this.PARAMS_MAP).forEach((key: string) => {
                const value = this.getItem(key as AffTrackParam);
                if(value) {
                    affTrackInfo[key as AffTrackParam] = value;
                }
            });
            return affTrackInfo;
        }
        return undefined;
    }

    private getItem(key: keyof AffTrackInfo): string | undefined {
        const k = this.LS_PREFIX + key;
        return this.cookies[k] || (localStorage.getItem(k) ?? undefined);
    }

    private setItem(key: string, value: string): void {
        key = this.LS_PREFIX + key;
        localStorage.setItem(key, value);
        this.setCookie(key, value, this.COOKIE_TTL_DAYS);
    }

    private save(affTrackInfo: AffTrackInfo) {
        let key: keyof AffTrackInfo;
        for(key in affTrackInfo) {
            const val = affTrackInfo[key];
            val && this.setItem(key, val);
        }
    }

    private setCookie(name: string, value: string, days: number) {
        if (value == null) return;
        const maxAge = days * 24 * 60 * 60;
        document.cookie =
            `${encodeURIComponent(name)}=${encodeURIComponent(value)};` +
            `Max-Age=${maxAge}; Path=/; SameSite=Lax; Secure`;
    }

    private loadCookies() {
        const out: Record<string, string> = {};
        if (!document.cookie) {
            this.cookies = {};
            return;
        };
        for (const part of document.cookie.split('; ')) {
            const eq = part.indexOf('=');
            const k = decodeURIComponent(part.substring(0, eq));
            const v = decodeURIComponent(part.substring(eq + 1));
            out[k] = v;
        }
        this.cookies = out;
    }
}
